import { localStorageHandler } from 'core/services';

export default function displayChatWidget() {
	if (process.env.NODE_ENV === 'development') return;

	if (window.HubSpotConversations) {
		display();
	} else {
		window.hsConversationsOnReady = window.hsConversationsOnReady || [];
		window.hsConversationsOnReady.push(display);
	}
}

const display = () => {
	if (localStorageHandler.get('react-baasic-token')) {
		window.HubSpotConversations.widget.load();
	} else {
		window.HubSpotConversations.widget.remove();
	}
};
